import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CLIENT_GROUPS_QUERY_KEY } from '@/hooks/useClientGroups';
import { selfClaimProperty } from '@/services/api/properties/api';

export const useSelfClaimProperty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: selfClaimProperty,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['properties'] });
      await queryClient.invalidateQueries({ queryKey: CLIENT_GROUPS_QUERY_KEY });
    },
  });
};
